import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { menuItems } from "../menu/menuItems";
// Unified simple outline SVG helper mapping to avoid Lucide external bundle problems in compilation.
// These match standard outline weight of Lucide.
export const IconMap = {
  dashboard: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  ),
  universidade: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
    </svg>
  ),
  projetos: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
  ),
  crm: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ),
  financeiro: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  marketing: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
    </svg>
  ),
  documentos: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
    </svg>
  ),
  agenda: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  ia: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  comunidade: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
    </svg>
  ),
  configuracoes: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  perfil: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  )
};

const desktopMenuItems = [
  { value: "dashboard", label: "Dashboard", path: "/dashboard" },
  { value: "universidade", label: "Universidade", path: "/universidade" },
  { value: "projetos", label: "Projetos", path: "/projetos" },
  { value: "crm", label: "CRM", path: "/crm" },
  { value: "financeiro", label: "Financeiro", path: "/financeiro" },
  { value: "marketing", label: "Marketing", path: "/marketing" },
  { value: "documentos", label: "Documentos", path: "/documentos" },
  { value: "agenda", label: "Agenda", path: "/agenda" },
  { value: "ia", label: "IA", path: "/ia" },
  { value: "comunidade", label: "Comunidade", path: "/comunidade" },
  { value: "configuracoes", label: "Configurações", path: "/configuracoes" }
];

const mobileMenuItems = [
  { value: 'dashboard', label: 'Dashboard' },
  { value: 'agenda', label: 'Agenda' },
  { value: 'crm', label: 'CRM' },
  { value: 'ia', label: 'IA' },
  { value: 'perfil', label: 'Perfil' },
];

const adminMenuItem = {
  value: "gestao",
  label: "Gestão do Sistema",
  path: "/admin"
};

export function Sidebar({ active = 'dashboard', onChange }) {

  const [usuario, setUsuario] = useState(null);


  useEffect(() => {

    const usuarioSalvo = localStorage.getItem("usuario");

    if (usuarioSalvo) {
      setUsuario(JSON.parse(usuarioSalvo));
    }

  }, []);



  const isGestor =
  usuario?.perfil === "GESTOR";

const menuItems = isGestor
  ? [...desktopMenuItems, adminMenuItem]
  : desktopMenuItems;

  return (

    <aside className="
      w-64
      bg-white
      border-r
      border-border
      h-screen
      sticky
      top-0
      flex
      flex-col
      font-body
      py-6
    ">


      <div className="
        px-6
        mb-8
        flex
        items-center
        gap-3
      ">

        <div className="
          w-8
          h-8
          rounded-lg
          bg-primary
          flex
          items-center
          justify-center
          text-white
          font-display
          font-semibold
          text-lg
        ">
          S
        </div>


        <span className="
          font-display
          text-xl
          font-bold
          tracking-tight
          text-primary
        ">
          SON
        </span>


      </div>



      <nav className="
        flex-1
        px-4
        space-y-1
        overflow-y-auto
      ">


        {
          menuItems.map((item)=>{


            const isActive =
              active === item.value;



            return (

<Link
  key={item.value}
  to={item.path}
  onClick={() => onChange?.(item.value)}
  className={`
    w-full
    flex
    items-center
    gap-3.5
    px-4
    py-3
    rounded-button
    text-small
    font-medium
    transition-all
    ${
      active === item.value
      ? "bg-primary text-white font-semibold"
      : "text-text-secondary hover:text-text-primary hover:bg-background"
    }
  `}
>

  {IconMap[item.value]}

  <span>
    {item.label}
  </span>

</Link>

            )

          })
        }


      </nav>


    </aside>

  );

}